<template>
  <b-modal
    :id="deviceObject.device_name"
    title="Επεξεργασία Συσκευής"
    centered
    hide-footer
  >
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            Επεξεργασία Συσκευής
          </h4>
          <b-spinner
            v-show="spinner"
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner>
          <b-alert
            v-show="alert.alertShow"
            show
            dismissible
            :variant="alert.alertVariant"
            >{{ alert.alertMsg }}</b-alert
          >

          <p class="card-title-desc">
            Στοιχεία Συσκευής
          </p>
          <div class="row">
            <div class="col-xl-4">
              <p>Face Version : {{ deviceObject.face_version }}</p>
              <p>Platform : {{ deviceObject.platform }}</p>
              <p>
                FirmWare Version :
                {{ deviceObject.firmware_version }}
              </p>
            </div>
            <div class="col-xl-4">
              <p>Mac Address : {{ deviceObject.mac_address }}</p>
              <p>Pin Width : {{ deviceObject.pin_width }}</p>
              <p>Face Fun on : {{ deviceObject.ffo }}</p>
              <p>Serial Number :{{ deviceObject.serial_number }}</p>
            </div>
            <div class="col-xl-4">
              <p>
                Factory name :
                {{ deviceObject.device_factory_name }}
              </p>
              <p>Mask : {{ deviceObject.mask }}</p>
              <p>GateWay : {{ deviceObject.gateway }}</p>
            </div>
          </div>
          <hr />
          <p class="card-title-desc">
            Συμπληρώστε την παρακάτω φόρμα για επεξεργασία συσκευής
          </p>

          <form
            class="needs-validation"
            @submit.prevent="deviceUpdateFormSubmit(deviceObject.id)"
          >
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="validationCustom01">Όνομα Συσκευής</label>
                  <input
                    id="validationCustom01"
                    type="text"
                    class="form-control"
                    placeholder="Ονομα Συσκευής"
                    required
                    :value="deviceObject.device_name"
                    @change="
                      (event) => (this.device.deviceName = event.target.value)
                    "
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="validationCustom02">IP</label>
                  <input
                    id="validationCustom02"
                    type="text"
                    class="form-control"
                    placeholder="IP Συσκευής"
                    required
                    :value="deviceObject.device_ip"
                    @change="
                      (event) => (this.device.deviceIP = event.target.value)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="validationCustom03">Port</label>
                  <input
                    id="validationCustom03"
                    type="text"
                    class="form-control"
                    placeholder="Port"
                    required
                    :value="deviceObject.device_port"
                    @change="
                      (event) => (this.device.devicePort = event.target.value)
                    "
                  />
                </div>
              </div>
            </div>
            <div class="form-check mb-3">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="deviceObject.active"
                id="invalidCheck"
                @change="changeActive"
              />
              <label class="form-check-label" for="invalidCheck">
                Ενεργό
              </label>
            </div>

            <button class="btn btn-primary" type="submit">
              Ολοκλήρωση
            </button>
          </form>
        </div>
      </div>
      <!-- end card -->
    </div>
  </b-modal>
</template>

<script>
import session from "../../../../../api/session";
import { eventCreate } from "../../../../../eventspy";
export default {
  name: "UpdateDeviceModal",
  props: {
    deviceObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      device: {
        deviceName: this.deviceObject.device_name,
        deviceIP: this.deviceObject.device_ip,
        devicePort: this.deviceObject.device_port,
        active: this.deviceObject.active,
      },
      spinner: false,
      alert: {
        alertShow: false,
        alertMsg: "",
        alertVariant: "success",
      },
    };
  },
  methods: {
    async deviceUpdateFormSubmit(deviceID) {
      this.spinner = true;
      await session
        .put(`api/device/${deviceID}/update/`, {
          device_name: this.device.deviceName,
          device_ip: this.device.deviceIP,
          device_port: this.device.devicePort,
          active: this.device.active,
        })
        .then(() => {
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertMsg = "Τα στοιχεία της συσκευής ανανεώθηκαν";
          this.alert.alertVariant = "success";
          this.$emit("deviceUpdated");
          setTimeout(() => {
            this.alert.alertShow = false;
            this.alert.alertMsg = "";
            this.$bvModal.hide(this.deviceObject.device_name);
          }, 2000);

          eventCreate(
            `Ανανέωσε την συσκευή 
            ${this.device.deviceName}, 
              device_name :${this.deviceObject.device_name}
            device_ip: ${this.deviceObject.device_ip}, 
            device_port: ${this.deviceObject.device_port},
            active: ${this.deviceObject.active} 
           
            ------------------------------------------
            device_name :${this.device.deviceName}
            device_ip: ${this.device.deviceIP}, 
            device_port: ${this.device.devicePort},
            active: ${this.device.active} `,
            2
          );
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertMsg =
            "Κάτι πήγε στραβά, παρακαλώ επικοινωνήστε με τους διαχειριστές";
          this.alert.alertVariant = "danger";
          setTimeout(() => {
            this.alert.alertShow = false;
            this.alert.alertMsg = "";
            this.$bvModal.hide(this.deviceObject.device_name);
          }, 2000);
        });
    },
    changeActive() {
      this.device.active = !this.device.active;
    },
  },
};
</script>
